var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"mt-1"},[_c('KinsTable')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center justify-content-center mt-4 border-bottom"},[_c('h4',{staticClass:"text-capitalize font-weight-light d-flex"},[_c('span',{staticClass:"d-flex"},[_c('i',{staticClass:"ri-user-heart-fill mr-1"})]),_vm._v(" next of kins ")])])
}]

export { render, staticRenderFns }